module.exports = __webpack_public_path__ + "img/91.d4a39af6.png";